export const APP_ROOT = '/app';

export const LOGIN_PATH = APP_ROOT + '/login';
export const DEVICES_PATH = APP_ROOT + '/devices';


// WEBPACK FOOTER //
// ./src/constant/routes.js